<template>
	<div v-if="loading">
    Loading ...
  </div>
	<div v-else>

		<table>
			<thead>
				<tr>
					<th></th>
					<th>Product</th>
					<th>Qty</th>
					<th>Unit price, incl. VAT</th>
					<th></th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, r) in getLines">
					<td style="width: 90px;">
						<img
							v-if="row.product.thumbnail && !isLowDataMode"
							:src="row.product.thumbnail"
							style="max-height: 60px; max-width: 60px;" />

						<template v-if="isLowDataMode">[Low data mode]</template>
					</td>
					<td>
						<a :href="'/#/product/' + row.product.id">
							<template v-if="row.variant">
								{{ row.variant.sku }}
							</template>
							<template v-else>
								{{ row.product.sku }}
							</template>
						</a>
						<div v-if="row.variant" class="note" style="margin-top: 5px;">
							{{ row.variant.ean_code }} &nbsp;|&nbsp; {{ row.variant.id }}
						</div>
						<div v-else-if="row.product.ean_code" class="note" style="margin-top: 5px;">
							{{ row.product.ean_code }} &nbsp;|&nbsp; {{ row.product.id }}
						</div>
					</td>
					<td>
						<div v-if="edit_lines[row.id]">
              <div class="error" v-if="[
                'loyalty',
                'Rabat',
                'annoanno-2',
                'annoanno-3',
              ].indexOf(row.product.sku) >= 0">Changing this line directly is not recommended.</div>
              <div class="flex">
                <MaterialNumber
                  v-on:enter="updateLine(row)"
                  v-on:esc="cancelLine(row)"
                  :disabled="saving"
                  v-model="row.qty"
                  label="Qty"
                  class="short" />
                <MaterialNumber
                  v-on:enter="updateLine(row)"
                  v-on:esc="cancelLine(row)"
                  :disabled="saving"
                  v-model="row.qty_returned"
                  label="Returned qty"
                  class="short small-margin-left" />
                <MaterialNumber
                  v-on:enter="updateLine(row)"
                  v-on:esc="cancelLine(row)"
                  :disabled="saving"
                  v-model="row.change_stock_qty"
                  label="Change stock"
                  class="short small-margin-left" />
              </div>
						</div>
						<template v-else-if="row.qty_returned">
							<span style="text-decoration: line-through; color: #888;">{{ row.qty }}</span>
							<span style="display: inline-block; margin-left: 10px;">{{ row.qty - row.qty_returned }}</span>
						</template>
						<template v-else>
							{{ row.qty }}
						</template>
					</td>
					<td>
						<template v-if="edit_lines[row.id]">
							<MaterialNumber
								v-on:enter="updateLine(row)"
								v-on:esc="cancelLine(row)"
								:disabled="saving"
								v-model="row.purchase_unit_price"
								label="Unit price"
								class="short" />
						</template>
						<template v-else>
							<template v-if="data.currency">{{ data.currency.code }} </template>
							<Format style="display: inline-block;" type="number" :value="row.purchase_unit_price" />
							<span v-if="row.purchase_unit_price !== row.normal_unit_price" class="discounted-price">
								<Format style="display: inline-block;" type="number" :value="row.normal_unit_price" />
							</span>
						</template>
					</td>
					<td>
						<div class="flex">
							<SvgIcon name="edit" v-on:click="toggleEditLine(row)" class="clickable" />
							<SvgIcon name="delete" v-on:click="remove(row)" class="clickable small-margin-left" />
						</div>
					</td>
					<td>
						<div v-if="row.variant !== null">
							<div class="small-margin-left text-right margin-bottom">
								<template v-if="product_discount[row.id]">
									<input type="number" v-model="discount[row.id]">
									<select v-model="discount_type[row.id]">
										<option selected value="percentage">%</option>
										<option value="fixed_amount">Fixed</option>
									</select>
								</template>
							</div>
							<div class="text-right small-margin-left">
								<button v-on:click="toggleDiscountForm(row)" v-if="!product_discount[row.id]">Apply discount
								</button>
								<button :disabled="saving" v-on:click="toggleDiscountForm(row)" v-if="product_discount[row.id]"
										class="gray">Cancel
								</button>
								<button :disabled="saving" v-on:click="applyDiscount(row)" v-if="product_discount[row.id]"
										class="small-margin-left">Apply
								</button>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

    <div
      class="error padding-top"
      v-if="add_product.sku === 'loyalty'">
      It is not recommended that loyalty be added manually. Adding loyalty directly to the order does not affect
      the customer's wallet and your entry may be overwritten by the correct loyalty when the order is recalculated.
    </div>

		<div class="flex margin-top">
			<ProductSearch
				v-if="!add_product.product_id && !add_product.variant_id"
				v-on:select-product="productSelected"
				v-on:select-variant="variantSelected" />
			<template v-else>
				<div>
					Adding
					<h3 style="margin: 0px;">{{ add_product.sku }}</h3>
				</div>
			</template>

			<template v-if="add_product.product_id || add_product.variant_id">
				<div class="margin-left">
					<MaterialNumber
						:disabled="saving"
						v-on:enter="add"
						v-on:esc="cancelAdd"
						v-model="add_product.qty"
						label="Qty"
						class="short" />
				</div>
				<div class="margin-left">
					<MaterialNumber
						:disabled="saving"
						v-on:enter="add"
						v-on:esc="cancelAdd"
						v-model="add_product.unit_price"
						label="Unit price"
						class="short" />
				</div>
				<div class="margin-left">
					<MaterialToggle label="Check stock" v-model="add_product.check_stock" />
				</div>
				<div class="margin-left">
					<button v-on:click="cancelAdd" class="gray small-margin-right">Cancel</button>
					<button :disabled="saving" v-on:click="add">Add</button>
				</div>
			</template>
		</div>

		<div class="small-margin-top note">
			Press <strong>ENTER</strong> to add, or <strong>ESC</strong> to cancel
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'order',
    'lines'
  ],
  data: () => ({
    loading: false,
    saving: false,
    discount: {},
    discount_type: {},
    product_discount: {},
    data: {},
    add_product: {
      check_stock: true
    },
    edit_lines: {}
  }),
  computed: {
    ...mapGetters([
      'isLowDataMode'
    ]),
    getLines () {
      return this.order ? this.data.shop_lines : this.lines.shop_lines
    }
  },
  methods: {
    updateLine (line) {
      Vue.$api.patch('/order/' + this.getOrderId() + '/line/' + line.id, line, {
        loader: toggle => this.saving = toggle,
        callback: data => this.$emit('reloadParent')
      })
    },
    cancelLine (line) {
      Vue.set(this.edit_lines, line.id, false)
    },
    toggleEditLine (line) {
      Vue.set(this.edit_lines, line.id, !this.edit_lines[line.id])
    },
    toggleDiscountForm (line) {
      Vue.set(this.discount_type, line.id, 'percentage')
      Vue.set(this.product_discount, line.id, !this.product_discount[line.id])
    },
    reload () {
      if (this.order) {
        this.load()
      }
    },
    remove (line) {
      const confirmMessage = line.product.sku === 'loyalty'
        ? 'Removing the loyalty line does NOT return loyalty to the wallet. Do you want to continue?'
        : 'Are you sure?'

      if (confirm(confirmMessage)) {
        var url = '/order/{id}/line/{lid}?check_if_invoiced=1'
          .replace('{id}', this.getOrderId())
          .replace('{lid}', line.id)
          .replace('{pid}', line.variant_id ? line.variant_id : line.product_id)

        Vue.$api.delete(url, {}, {
          loader: toggle => this.saving = toggle,
          callback: data => this.reload()
        })
      }
    },
    getOrderId () {
      return this.order
    },
    /**
     * Add a product to the order.
     *
     * @param {boolean} force - Flag to indicate if the warehouse status check should be disabled.
     * @return {void}
     */
    add (force) {
      const url = '/order/{id}/product/{pid}'
        .replace('{id}', this.getOrderId())
        .replace('{pid}', this.add_product.product_id
          ? this.add_product.product_id
          : this.add_product.variant_id
        )
      const param = {
        qty: this.add_product.qty,
        unit_price: this.add_product.unit_price,
        ignore_stock: !this.add_product.check_stock
      }
      if (force !== undefined && force === true) {
        param.disable_warehouse_status_check = 1
      }
      Vue.$api.post(url, param, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          if (this.order) {
            this.load()
          }
        },
        error: (err) => {
          if (err.data === undefined || err.data.exception !== "UnprocessableEntityHttpException") {
            return
          }
          if (err.data.message !== "The order cannot be changed because order is already sent to warehouse") {
            return
          }
          if (confirm("Do you want to add this item anyway?")) {
            this.add(true)
          }
        }
      })
    },
    cancelAdd () {
      this.add_product = {
        check_stock: true
      }
    },
    productSelected (product) {
      this.add_product = {
        sku: product.sku,
        product_id: product.id,
        qty: 1,
        unit_price: this.extractPrice(product.prices),
        check_stock: true
      }
    },
    variantSelected (variant) {
      this.add_product = {
        sku: variant.sku,
        variant_id: variant.id,
        qty: 1,
        unit_price: this.extractPrice(variant.prices),
        check_stock: true
      }
    },
    extractPrice (prices) {
      for (var price of prices) {
        if (price.currency_id == this.data.currency.id) {
          return price.price
        }
      }

      return 0
    },
    load () {
      Vue.$api.get('/order/' + this.order + '/products/all', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.data = data
    },
    applyDiscount (row) {
      if (undefined == this.discount[row.id]) {
        alert('Please insert a value for discount')
        return
      }
      var data = {}
      var url = '/order/{id}/apply-product-discount/{pid}'
        .replace('{id}', this.getOrderId())
        .replace('{pid}', row.variant_id)
      data[this.discount_type[row.id]] = this.discount[row.id]
      Vue.api.post(url, data, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => {
          this.toggleDiscountForm(row)
          this.$emit('reloadParent')
        }
      })
    }
  },
  created () {
    if (this.order) {
      this.load()
    }
  }
}
</script>
<style scoped>
	.discounted-price div{
		margin-left: 10px;
		text-decoration: line-through;
	}
</style>
